var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 725.002,
    height: 725,
    viewBox: "0 0 725.002 725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_45",
    x: 0,
    y: 0,
    width: 725.002,
    height: 725,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20,
    dy: 60,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_programmer_re_owql",
    transform: "translate(93.501 13.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -93.5, -13.5)",
    filter: "url(#Path_45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2",
    "data-name": "Path 45",
    d: "M889,450a287.861,287.861,0,0,1-68.09,186.34c-1.6,1.9-3.23,3.77-4.89,5.63a290.59,290.59,0,0,1-67.49,55.99q-8.67,5.205-17.72,9.81c-.61.31-1.23.62-1.84.92-.73.37-1.47.73-2.21,1.09A286.161,286.161,0,0,1,679.24,728q-2.55.72-5.11,1.4a288.585,288.585,0,0,1-65.84,9.49c-1.16.03-2.3.05-3.4.07-.39.01-.77.02-1.15.02-1.25.01-2.49.02-3.74.02a289.275,289.275,0,0,1-69.54-8.43q-3.42-.84-6.81-1.77a285.472,285.472,0,0,1-34.97-12.03q-9-3.75-17.68-8.09c-1.31-.66-2.62-1.32-3.91-2-.55-.27-1.09-.56-1.63-.84a290.457,290.457,0,0,1-81.65-64.06c-1.6-1.79-3.17-3.61-4.72-5.44a289.025,289.025,0,0,1,49.59-419.1c1.64-1.21,3.29-2.41,4.96-3.58l.99-.69a286.754,286.754,0,0,1,97.1-43.85c1.98-.49,3.96-.95,5.96-1.38a291.8,291.8,0,0,1,114.68-2.01c1.99.37,3.98.75,5.96,1.16a287.281,287.281,0,0,1,97.1,39.43c.66.42,1.32.84,1.98,1.28,1.33.86,2.66,1.74,3.97,2.63A288.686,288.686,0,0,1,889,450Z",
    transform: "translate(-217.5 -147.5)",
    fill: "#110c26"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M527,599.51l-92.37,8.2-.99.09V213.66l.99-.69a288.32,288.32,0,0,1,62.01-32.94l4.72,65.1.43,5.96,4.67,64.56,1.44,19.86,18.93,261.7Z",
    transform: "translate(-311 -161)",
    fill: "#20193f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M755.43,206.32c.66.42,1.32.84,1.98,1.28V607.8l-1.98-.18-91.37-8.11.17-2.3,18.93-261.7,1.44-19.86,4.67-64.56.43-5.96,4.95-68.27a287.687,287.687,0,0,1,60.78,29.46Z",
    transform: "translate(-311 -161)",
    fill: "#20193f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M755.43,206.32V613.26c0,7.81-5.38,14.16-12,14.16H446.63c-5.48,0-10.13-4.36-11.54-10.31a16.107,16.107,0,0,1-.46-3.85V212.97l-.99.69c-1.67,1.17-3.32,2.37-4.96,3.58V613.26a22.919,22.919,0,0,0,6.18,16,17.059,17.059,0,0,0,7.78,4.66,15.117,15.117,0,0,0,3.99.53h296.8a15.246,15.246,0,0,0,4-.53c7.98-2.15,13.95-10.59,13.95-20.66V210.23c-1.31-.89-2.64-1.77-3.97-2.63C756.75,207.16,756.09,206.74,755.43,206.32Z",
    transform: "translate(-311 -161)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 326.752,
    height: 5.959,
    transform: "translate(120.655 84.134)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M531.73,169.12c1.98-.49,3.96-.95,5.96-1.38V329.55h-5.96Z",
    transform: "translate(-311 -161)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M652.37,165.73c1.99.37,3.98.75,5.96,1.16V329.55h-5.96Z",
    transform: "translate(-311 -161)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M795.65,597.21H404.34a26.82,26.82,0,0,0,0,53.64H795.65a26.763,26.763,0,0,0,20.124-9.114,27.1,27.1,0,0,0,3.016-4.176,25.547,25.547,0,0,0,1.75-3.56,26.8,26.8,0,0,0-24.89-36.79Z",
    transform: "translate(-311 -161)",
    fill: "#20193f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 324.766,
    height: 19.863,
    transform: "translate(122.642 154.649)",
    fill: "#20193f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M282.045,148.69H288a10.925,10.925,0,0,1,10.925,10.925H271.12a10.925,10.925,0,0,1,10.925-10.925Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M820.91,636.34a289,289,0,0,1-28.12,28.95H407.21a289.009,289.009,0,0,1-28.12-28.95Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M632.28,536.07H567.36a3.175,3.175,0,0,0-1.03.16,3.448,3.448,0,0,0-2.43,3.3V642.09h71.85V539.53a3.463,3.463,0,0,0-3.47-3.46Zm-24.57,50.6a7.531,7.531,0,0,1-1.56,4.6,7.665,7.665,0,0,1-13.78-4.6v-11.9a7.67,7.67,0,1,1,15.34,0Z",
    transform: "translate(-311 -161)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M563.68,638.81v9.89a1.94,1.94,0,0,0,1.93,1.94h68.43a1.946,1.946,0,0,0,1.93-1.94v-9.89Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M739.78,376.02H462.28a9.011,9.011,0,0,0-9,8.99V572.27a9.007,9.007,0,0,0,9,9h277.5a9.007,9.007,0,0,0,9-9V385.01a9.012,9.012,0,0,0-9-8.99Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M737.46,382.52H464.59a4.82,4.82,0,0,0-4.81,4.82V569.96a4.818,4.818,0,0,0,4.81,4.81H737.46a4.818,4.818,0,0,0,4.81-4.81V387.34a4.82,4.82,0,0,0-4.81-4.82Z",
    transform: "translate(-311 -161)",
    fill: "#724cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M687.24,650.48l-2.52-11.97a2.992,2.992,0,0,0-1.86-2.17,2.894,2.894,0,0,0-1.06-.2H524.49a2.894,2.894,0,0,0-1.06.2,2.993,2.993,0,0,0-1.86,2.17l-2.52,11.97a2.987,2.987,0,0,0,2.92,3.6H684.31a2.948,2.948,0,0,0,2.32-1.11,2.985,2.985,0,0,0,.61-2.49Z",
    transform: "translate(-311 -161)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(214.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(224.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(234.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(244.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(254.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(264.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(274.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(284.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(294.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(304.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(314.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(324.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(334.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(344.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(354.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(364.643 477.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(214.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(224.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(234.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(244.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(254.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(264.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(274.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(284.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(294.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(304.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(314.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(324.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(334.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(344.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(354.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 5,
    height: 3,
    rx: 0.488,
    transform: "translate(364.525 482.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 40,
    height: 3,
    rx: 0.488,
    transform: "translate(262.525 488.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M723.748,407.677H468.425a1.015,1.015,0,1,1,0-2.031H723.748a1.015,1.015,0,1,1,0,2.031Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 5.95,
    cy: 6.083,
    rx: 5.95,
    ry: 6.083,
    transform: "translate(168.855 227.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 5.95,
    cy: 6.083,
    rx: 5.95,
    ry: 6.083,
    transform: "translate(189.411 227.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 5.95,
    cy: 6.083,
    rx: 5.95,
    ry: 6.083,
    transform: "translate(209.967 227.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M711.37,389.8h-14.6a1.105,1.105,0,0,0,0,2.21h14.6a1.105,1.105,0,1,0,0-2.21Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M711.37,393.95h-14.6a1.105,1.105,0,0,0,0,2.21h14.6a1.105,1.105,0,1,0,0-2.21Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M711.37,398.1h-14.6a1.105,1.105,0,0,0,0,2.21h14.6a1.105,1.105,0,1,0,0-2.21Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(171.314 270.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(231.314 270.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(248.314 270.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(187.634 269.793)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(267.634 269.793)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(187.314 283.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(247.314 283.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(264.314 283.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(203.634 282.793)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(283.634 282.793)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(203.314 296.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(263.314 296.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(280.314 296.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(219.634 295.793)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(299.634 295.793)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(219.314 309.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(279.314 309.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(296.314 309.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(235.634 308.793)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(231.314 360.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(248.314 360.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(267.634 361.447)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(171.314 360.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(187.634 361.447)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(187.314 347.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(247.314 347.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(264.314 347.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(203.634 348.447)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(203.314 334.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(263.314 334.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(280.314 334.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(219.634 335.447)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(219.314 321.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(279.314 321.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 11.006,
    height: 5.76,
    rx: 2.88,
    transform: "translate(296.314 321.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 38.366,
    height: 5.76,
    rx: 2.88,
    transform: "translate(235.634 322.447)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M726.81,709.77c-.61.31-1.23.62-1.84.92-15.8,7.9-28.44,12.39-45.73,17.31-1.46-16.3-2.87-44.95-4.24-62.71-.36-4.61-.72-8.48-1.07-11.21a15.183,15.183,0,0,0-.88-4.25l.06,4.25.15,11.21.87,64.11a288.588,288.588,0,0,1-65.84,9.49c-1.16.03-2.3.05-3.4.07-.39.01-.77.02-1.15.02-1.25.01-2.49.02-3.74.02a289.269,289.269,0,0,1-69.54-8.43c.49-16.13.98-44.46,1.45-65.28.1-4.07.19-7.86.29-11.21.19-7.16.39-12.32.58-14.05a4.362,4.362,0,0,0-.39.97,97.157,97.157,0,0,0-1.89,13.08c-.35,3.35-.7,7.14-1.05,11.21-1.86,21.63-3.8,51.04-5.8,63.51a285.472,285.472,0,0,1-34.97-12.03q-9-3.75-17.68-8.09c1.1-7.2,2.25-15.27,3.43-23.64.92-6.49,1.87-13.16,2.84-19.75,1.5-10.18,3.04-20.16,4.6-28.95,2.28-12.84,4.62-23.16,6.94-27.9,2.2-4.5,4.4-8.94,6.53-13.19.74-1.49,1.48-2.96,2.2-4.39.17-.34.34-.67.51-1,1.53-3.01,3.01-5.89,4.42-8.59,1.21-2.31,2.36-4.49,3.45-6.5,2.64-4.88,4.88-8.77,6.54-11.23a55.257,55.257,0,0,1,29.28-22.21l.3-.08.21.09,20.45-6.28,2.99-.92,2.01-.62,7.08-5.39,3.85-2.93,3.61-2.75,7.06-5.37,43.71,2.69,8.51,20.49,19.06,6.97.33-.15.29-.12.3.08a55.306,55.306,0,0,1,29.28,22.21c.94,1.41,2.08,3.27,3.37,5.52,1.1,1.91,2.3,4.09,3.6,6.5,1.85,3.43,3.87,7.3,6.01,11.49.47.92.95,1.86,1.43,2.81q1.335,2.64,2.71,5.39c2.13,4.25,4.33,8.69,6.53,13.2,1.91,3.91,3.84,11.95,5.74,22.18,1.57,8.5,3.13,18.52,4.64,28.95,1.98,13.52-.13,29.71,1.66,42.15C726.58,708.23,726.7,709,726.81,709.77Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 50.836,
    cy: 50.836,
    r: 50.836,
    transform: "translate(238.779 238.052)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M684.45,382.52a26.608,26.608,0,0,0-3.97-6.5c-7.72-9.43-21.76-13.58-36.17-2.42a15.279,15.279,0,0,0-8.35.48,12.91,12.91,0,0,0-3.52,1.94,15.971,15.971,0,0,0-4.94,6.5,15.523,15.523,0,0,0-1.1,4.23,50.567,50.567,0,0,0-11.23-4.23,60.34,60.34,0,0,0-29.13,0,36.545,36.545,0,0,0-8.78,3.48c-4.68,2.7-7.37,6.11-7.85,9.9-6.75.38-13.77,3.93-19,9.75-.59.65-1.16,1.33-1.69,2.03A32.709,32.709,0,0,0,542,427.73V429h1.27a26.869,26.869,0,0,1,10.15,1.98,27.588,27.588,0,0,1,5.89,3.25,28.767,28.767,0,0,1,3.37,2.8,33.484,33.484,0,0,1,6.12,8.05,37.46,37.46,0,0,1,4.08,24.71,36.2,36.2,0,0,1-1.52,5.76,37.583,37.583,0,0,1-3.71,7.63c-.06.09-.11.18-.17.27-.67,1.07-1.31,2.16-1.91,3.26-.45.82-.87,1.66-1.26,2.5a51.941,51.941,0,0,0-2.88,7.24,53.587,53.587,0,0,0-2.44,13.54c-.07,1.22-.09,2.44-.05,3.66a51.982,51.982,0,0,0,1.03,9.36c.09.42.18.83.27,1.25l.73,3.19,1.73,7.61,1.2,5.24,1.11,4.86,1.64-2.35c.56-.8,1.97-3.26,3.86-6.74,1.25-2.27,2.7-4.98,4.27-7.94,2.19-4.15,4.59-8.78,6.94-13.4.95-1.87,1.89-3.73,2.8-5.55,1.72-3.45,3.34-6.78,4.73-9.74,1.28-2.73,2.37-5.15,3.18-7.09.25,1.27.46,2.56.62,3.86.18,1.32.31,2.66.38,4,.02.2.03.41.04.61l.04.82.01.24,1.06.14a93.019,93.019,0,0,0,18.4.14h.01a74.861,74.861,0,0,0,23.56-5.71,49.258,49.258,0,0,0,11.8-7.24,41.3,41.3,0,0,0,4.66-4.52c.36-.41.71-.82,1.05-1.24a41.125,41.125,0,0,0,5.05-7.9,41.794,41.794,0,0,0,2.34-5.76c3.84-11.63,3.62-26.14-.66-43.38a9.924,9.924,0,0,0,3.27-1.26c3.14-1.89,5.32-5.64,6-10.22l1.08.29a30.105,30.105,0,0,0,10.01-7.54,24.116,24.116,0,0,0,1.54-2.03C687.58,398.45,687.62,389.81,684.45,382.52Z",
    transform: "translate(-311 -161)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M206.32,475.3l8.5-32.792,7.5,28.3Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M743.43,614.93c-3.04,41.88.11,60.32-16.67,94.85A286.175,286.175,0,0,1,679.24,728q-2.55.72-5.11,1.4a288.585,288.585,0,0,1-65.84,9.49c-1.16.03-2.3.05-3.4.07-.39.01-.77.02-1.15.02-1.25.01-2.49.02-3.74.02a289.275,289.275,0,0,1-69.54-8.43q-3.42-.84-6.81-1.77a285.472,285.472,0,0,1-34.97-12.03q-9-3.75-17.68-8.09c-1.31-.66-2.62-1.32-3.91-2-6.63-11.66-10.4-25.84-10.48-42.88C461.2,634.44,733.29,589.61,743.43,614.93Z",
    transform: "translate(-311 -161)",
    fill: "#724cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M743.422,622.1c.155-2.593.329-5.271.531-8.06-10.14-25.32-282.23,19.51-286.82,48.87.013,2.692.128,5.3.321,7.855C468.57,641.789,727.059,599.181,743.422,622.1Z",
    transform: "translate(-311 -161)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M474.1,503.152a6.365,6.365,0,0,0-6.753-6.816,5.858,5.858,0,0,0-1.005.126l-39.762,8.983a6.548,6.548,0,0,0-4.209,3.235,8.183,8.183,0,0,0-1.727.251,9.661,9.661,0,1,0,4.271,18.845,9.794,9.794,0,0,0,3.895-1.884l13.474,37.941a6.328,6.328,0,0,0,6.941,3.046l25.849-5.842A6.416,6.416,0,0,0,480,555.32Zm-49.781,21.923a6.91,6.91,0,1,1-3.078-13.474c.126-.031.251,0,.377-.031a6.507,6.507,0,0,0,.848,3.266l4.931,8.606a6.5,6.5,0,0,1-3.078,1.633Z",
    transform: "translate(-311 -161)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M467.343,496.336c.377,5.025-8.229,10.8-19.755,13.1-10.585,2.167-20.07.659-22.739-3.3a6.026,6.026,0,0,1,1.728-.691l39.762-8.983a5.846,5.846,0,0,1,1.005-.126Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M439.843,623.905l22.334-11.167-18.611-50.251-4.9-25.342a19.161,19.161,0,0,0-31.282-10.907h0a19.161,19.161,0,0,0-2.493,26.518l18.207,22.759Z",
    transform: "translate(-311 -161)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M462.177,603.433,432.4,618.322,455,689.131a30.977,30.977,0,0,0,22.336,20.716h0a30.977,30.977,0,0,0,33.737-14.2L571,592.936a31.62,31.62,0,0,0-10.2-42.982h0a31.62,31.62,0,0,0-45.3,12.765l-36.576,77.936Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M452.967,539.441a.5.5,0,0,1-.163-.027l-6.5-2.238a.5.5,0,0,1-.206-.811l4.835-5.265a.5.5,0,1,1,.736.676l-4.319,4.7,5.779,1.99a.5.5,0,0,1-.163.973Z",
    transform: "translate(-311 -161)",
    fill: "#724cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M461.878,537.617a.5.5,0,0,1-.348-.859l4.395-4.249-5.9-2.433a.5.5,0,0,1,.381-.924l6.609,2.724a.5.5,0,0,1,.157.821l-4.943,4.779a.5.5,0,0,1-.348.141Z",
    transform: "translate(-311 -161)",
    fill: "#724cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M454.332,542.5a.48.48,0,0,1-.147-.022.5.5,0,0,1-.331-.625l4.615-15a.5.5,0,1,1,.956.295l-4.615,15A.5.5,0,0,1,454.332,542.5Z",
    transform: "translate(-311 -161)",
    fill: "#724cf9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.295e8f89b6cdce01fd0d6668b0a0f041.svg";
export { ForwardRef as ReactComponent };